import { QuestionSelect } from "./QuestionSelect"
import type { TQuestionProps } from "./types"
import { getChoicesByBinaryMask } from "./utils"

export function QuestionMultiple({ value, setValue, ...props }: TQuestionProps) {
  const selected = getChoicesByBinaryMask(value || 0)
  return (
    <QuestionSelect
      value={value}
      selected={(idx) => selected.includes(idx)}
      setValue={(idx) => {
        if (idx === null) return
        const term = 2 ** idx
        const newValue = selected.includes(idx) ? value! - term : (value || 0) + term
        setValue(newValue)
      }}
      {...props}
    />
  )
}
